/*
 * SW4D-984 — Configurações da vitrine de Páginas Temáticas (Coleções).
 *
 * Endpoints reais (espelham o domínio de destaques de Programs):
 *   - GET  showcase/configuration            -> textos do cabeçalho + textos/ordenação da seção
 *   - GET  showcase/thematic_pages_highlights -> páginas em destaque (ordenado por highlightPosition ASC)
 *   - GET  api/thematic_pages                 -> páginas elegíveis (ativas + showonvitrine)
 *   - POST api/thematic_page_highlight        -> salva ordenação + textos da seção + destaques
 *   - POST api/configuration                  -> salva textos do cabeçalho (header_title/_subtitle)
 */
import { http } from '@/support/http'
import { createQuery } from '@/support/utils/paginatorQueryBuilder'

// Fields de configuração do cabeçalho da listagem de Coleções (vitrine).
const FIELD_HEADER_TITLE = 'thematic_page_header_title'
const FIELD_HEADER_SUBTITLE = 'thematic_page_header_subtitle'

/**
 * Configuração da seção de páginas temáticas (textos do cabeçalho + textos/ordenação da seção).
 * Response: { data: [ { field, value } ] } (showcase/configuration).
 */
export const getThematicPagesGeneralSettings = () => {
  return http.get('showcase/configuration')
}

/**
 * Salva os textos do cabeçalho da página de listagem de Coleções (vitrine).
 * payload: { title, subtitle } -> POST api/configuration (fields header_title/_subtitle).
 */
export const updateThematicPagesHeader = (payload = {}) => {
  const configurations = [
    {
      field: FIELD_HEADER_TITLE,
      value: payload.title || '',
      active: true
    },
    {
      field: FIELD_HEADER_SUBTITLE,
      value: payload.subtitle || '',
      active: true
    }
  ]

  return http.post('api/configuration', { configurations: JSON.stringify(configurations) })
}

/**
 * Lista de páginas temáticas elegíveis (ativas + "Exibir na Vitrine"), com busca/paginação.
 * Espelha getThematicPagesList (GET api/thematic_pages); filtro via createQuery do caller.
 * Response: { data: { data: [...], actualPage, lastPage, total } }.
 */
export const getEligibleThematicPages = (pagination = {}) => {
  const queryString = createQuery(pagination)

  return http.get(`api/thematic_pages?${queryString}`)
}

/**
 * Páginas temáticas atualmente em destaque (já ordenadas por highlightPosition ASC no backend).
 * Response: { data: { data: [ { thematicPage, highlightPosition } ] } }.
 */
export const getListThematicPagesHighlights = () => {
  return http.get('showcase/thematic_pages_highlights')
}

/**
 * Salva ordenação + textos da seção + destaques das páginas temáticas.
 * Espelha POST api/program_highlight.
 * payload: { ordenation, title, description, thematicPages: [ { thematicPageId, highlightPosition } ] }
 */
export const updateThematicPagesHighlights = (payload = {}) => {
  return http.post('api/thematic_page_highlight', payload)
}
